import { ApiResponse } from 'apisauce';

import { UsersPayload } from '@/Modules/UserManagement/shared/types';
import debugConfig from '@/shared/config/debug.config';
import api from '@/shared/config/http.config';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import { ResponseModel } from '@/shared/interfaces/response-model.interface';
import { UserAuthModel } from '@/shared/models/user-auth.model';
import { AddUserDataModel, UserModel } from '@/shared/models/user.model';
import { FcmDataModel, DeleteFcmDataModel } from '@/shared/models/fcm-data.model';
import userApiFixtureService from '@/shared/services/fixtures/user-api.service';
import { SearchUserModel } from '@/shared/services/store/global-add-user.store';

const apis = {
  registerUser: (user: AddUserDataModel): Promise<ApiResponse<UserAuthModel, ErrorInfo>> =>
    api.post('/auth/register', user),
  loginUser: (email: string, password: string): Promise<ApiResponse<UserAuthModel, ErrorInfo>> =>
    api.post('/auth/login', { email, password }),
  changePassword: (
    token: string,
    password: string
  ): Promise<ApiResponse<UserAuthModel, ErrorInfo>> =>
    api.post('/auth/changePassword', { token, password }),
  forgotPassword: (email: string): Promise<ApiResponse<object, ErrorInfo>> =>
    api.post('/auth/forgotPassword', { email }),
  validateToken: (): Promise<ApiResponse<object, ErrorInfo>> => api.get('/auth/verifyToken'),
  refreshToken: (refreshToken: string): Promise<ApiResponse<UserAuthModel, ErrorInfo>> =>
    api.post('/auth/refreshToken', { refreshToken }),
  getAllUsers: (query: UsersPayload): Promise<ApiResponse<ResponseModel<UserModel[]>, ErrorInfo>> =>
    api.post('/users/search', query),
  addUser: (userModel: UserModel): Promise<ApiResponse<ResponseModel<UserModel>, ErrorInfo>> =>
    api.post('/users/', userModel),
  searchUsers: ({
    phone,
    name,
    email,
    role
  }: SearchUserModel): Promise<ApiResponse<ResponseModel<UserModel>, ErrorInfo>> =>
    api.post('/users/searchOne', { phone, name, email, role }),
  getUserById: (userId: string): Promise<ApiResponse<ResponseModel<UserModel>, ErrorInfo>> =>
    api.get(`/users/${userId}`),
  addUnverifiedUser: (
    userData: AddUserDataModel
  ): Promise<ApiResponse<ResponseModel<AddUserDataModel>, ErrorInfo>> =>
    api.post('/users/addUser', userData),
  updateClientFcmToken: (fcmData: FcmDataModel): Promise<ApiResponse<object, ErrorInfo>> =>
    api.put('/clientToken', fcmData),
  deleteClientFcmToken: (fcmData: DeleteFcmDataModel): Promise<ApiResponse<object, ErrorInfo>> =>
    api.delete('/clientToken', {}, { params: fcmData }),
  getUserImage: (
    userId?: string
  ): Promise<ApiResponse<ResponseModel<{ url: string }>, ErrorInfo>> => {
    const endpoint = userId ? `/users/${userId}/image` : '/users/me/image';
    return api.get(endpoint);
  }
};

// TODO: Enhance the way of mocking APIs
export const userApi = debugConfig.useFixtures ? userApiFixtureService : apis;
